import { FC, useCallback, useMemo } from 'react'
import * as styles from 'components/features/pfm/QuickLookSection/QuickLookSection.styl'
import Anchor from 'components/atoms/navigation/Anchor'
import HighlightsContainer from 'components/features/pfm/Highlights/HighlightsContainer'
import { PageHeading } from 'components/atoms/Text'
import NetworthSummaryContainer from 'components/features/pfm/NetworthSummary/NetworthSummaryContainer'
import { PAGE_DEFINITIONS_MAP } from 'constants/pages'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { createTopPaneSelector } from 'selectors/floatingPanesSelectors'
import cn from 'classnames'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { linkedMixedAccountsGuard } from 'guards/linkageGuards'
import { useEnabledAccounts } from 'components/features/pageFilters/useEnabledAccounts'

type QuickLookSectionProps = {
}

export const QuickLookSection: FC<QuickLookSectionProps> = () => {
  useSimpleGuard(linkedMixedAccountsGuard, {}, 'QuickLookSection for account filtering')

  const enabledAccounts = useEnabledAccounts()

  const topPaneSelector = useMemo(createTopPaneSelector, [])
  const topPane = useStoreSelector(topPaneSelector)
  const isExpanded = useMemo(() => {
    return topPane?.type === 'page-filter' && topPane.mode === 'by-account'
  }, [topPane])

  const dispatch = useStoreDispatch()
  const handleClick = useCallback(() => {
    dispatch(new ModifyFloatingPaneAction({
      type: 'page-filter',
      mode: 'by-account',
      page: 'dashboard',
    }))
  }, [dispatch])

  const pageHeaderChild = useMemo(() => {
    const pageName = PAGE_DEFINITIONS_MAP['dashboard'].title

    return (
      <PageHeading className={ cn(styles.pageTitle, isExpanded && styles.expanded) } >
        { pageName }
        { enabledAccounts.count !== 0 && (
          <>
            <br />
            in
            { ' ' }
            <button type='button' onClick={ handleClick } data-qa-marker='accounts-filtering' data-qa-type='button'>
              <span data-qa-marker='enabled-accounts' data-qa-type='title'>
                { enabledAccounts.title }
              </span>
              <i className={ styles.arrow } />
            </button>
          </>
        )}
      </PageHeading>
    )
  }, [enabledAccounts.count, enabledAccounts.title, handleClick, isExpanded])

  return (
    <section className={ styles.quickLookSection }>
      <div className={ styles.headerWrapper }>
        { pageHeaderChild }
        <div className={ styles.networthSummaryWrapper }>
          <NetworthSummaryContainer />
        </div>
      </div>
      <Anchor placement='dashboard_opportunities'>
        <HighlightsContainer placement='dashboard_opportunities' />
      </Anchor>
    </section>
  )
}
